module.exports = __webpack_public_path__ + "img/copy-white.0a17b78d.svg";